// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__Td1C3","brand":"Badge_brand__2APt2","success":"Badge_success__CXdXs","warning":"Badge_warning__+6epT","neutral":"Badge_neutral__gLF6c"};